import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import "./App.css";

import HeaderComponent from "./component/HeaderComponent";

import FileScreen from "./screen/FileScreen";
import LoginScreen from "./screen/LoginScreen";
import AdminScreen from "./screen/AdminScreen";
import UserScreen from "./screen/UserScreen";
import MainScreen from "./screen/MainScreen";
import UploadScreen from "./screen/UploadScreen";
import AddProjectScreen from "./screen/AddProjectScreen";

function App() {
  const [login, setLogin] = useState(false);
  const [role, setRole] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("role");
    if (token) {
      setRole(role);
      setLogin(true);
    }
  }, []);
  return (
    <div className="App">
      {login && <HeaderComponent role={role} />}
      {login ? (
        <Routes>
          <Route path="/" element={<MainScreen />} />
          <Route path="/main" element={<MainScreen />} />
          <Route path="/file/:id" element={<FileScreen />} />
          <Route path="/admin" element={<AdminScreen />} />
          <Route path="/user" element={<UserScreen />} />
          <Route path="/upload" element={<UploadScreen />} />
          <Route path="/add-project" element={<AddProjectScreen />} />
          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      )}
    </div>
  );
}

export default App;
